"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var _immutable = require("immutable");

var initialState = (0, _immutable.fromJS)({
  admins: new _immutable.List()
});

var users = function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.ADMIN_FETCH_RECEIVED:
      return state.set('admins', (0, _immutable.fromJS)(action.payload));

    default:
      return state;
  }
};

var _default = users;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/users.js
// module id = 644
// module chunks = 209 210 211 212